import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ChevronRightSmall = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M12.2766478,10.2469389 C13.5206452,11.482755 14.5384615,12.4966441 14.5384615,12.5000253 C14.5384615,12.5121025 10.014535,17 10.0023614,17 C9.99552848,17 9.76720268,16.7786792 9.4949696,16.5081759 L9,16.0163519 L10.775991,14.2520285 L12.5519819,12.4877051 L10.7823337,10.7296832 L9.01268653,8.97166062 L9.50115989,8.4858308 C9.76982058,8.21862426 9.99530372,8 10.0022336,8 C10.0091636,8 11.0326503,9.01112292 12.2766478,10.2469389 Z"
        />
    </StarryUIIcon>
);
